import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { userLogout } from '../../store/authActions';
import Cookies from "js-cookie";
import ConfirmPopupHeader from './ConfirmPopupHeader';

function HeaderUser() {
  const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
  const navigate = useNavigate()
  const { userDetailLogin, planChangeStatus } = useSelector((state) => state.auth);
  const dispatch = useDispatch()

const [formData, setFormData] = useState({})
const location = useLocation()
const [popupMessage, setPopupMessage] = useState("")

const modalConfirmRef = useRef(null)
const modalInstanceConfirm = useRef(null);


const [isHeaderOpen, setHeaderOpen] = useState(false);
 
  const [openMegaMenu, setOpenMegaMenu] = useState(null);
  const [openMegaMenuMatch, setOpenMegaMenuMatch] = useState(null);
  const [openMegaMenuSearch, setOpenMegaMenuSearch] = useState(null);
  const [openMegaMenuInbox, setOpenMegaMenuInbox] = useState(null);
  const [userPlanDetail, setUserPlanDetail] = useState({})
  const [confirmYesNo, setConfirmYesNo] = useState(false)
  const [profileCompletion, setProfileCompletion] = useState("0%")

  const toggleHeader = () => {
    
    
    if(isHeaderOpen){
      setOpenMegaMenu(false);
      setOpenMegaMenuMatch(false);
      setOpenMegaMenuSearch(false);
      setOpenMegaMenuInbox(false);
    }
    
    setHeaderOpen((prev) => !prev);
    
  };

  

  const toggleMegaMenu = () => {
    setOpenMegaMenu((prev) => !prev);
  };
  const toggleMegaMenuMatch = () => {
    setOpenMegaMenuMatch((prev) => !prev);
  };
  const toggleMegaMenuSearch = () => {
    setOpenMegaMenuSearch((prev) => !prev);
  };
  const toggleMegaMenuInbox = () => {
    setOpenMegaMenuInbox((prev) => !prev);
  };


  


  const fetchUserDetail = async (userId) => {
      
      const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/user/user-detail-all/${userId}`, {
          method: "GET",
          headers: { "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
           },
          });
  
        const data = await res.json();
       
        if(data.status){
          
  
          const dob = new Date(data.data[0].dob);
          let ampm = "AM";
          let hour = dob.getHours();
          if (hour >= 12) {
            ampm = "PM";
            if (hour > 12) hour -= 12;
          } else if (hour === 0) {
            hour = 12; 
          }
  
          
        let profilePhoto;
                    if(data.data[0].profile_photo === 1){
                      profilePhoto = data.data[0].photo
                    } else if(data.data[0].profile_photo === 2){
                      profilePhoto = data.data[0].photo1
                    } else if(data.data[0].profile_photo === 3){
                      profilePhoto = data.data[0].photo2
                    } else if(data.data[0].profile_photo === 4){
                      profilePhoto = data.data[0].photo3
                    } else if(data.data[0].profile_photo === 5){
                      profilePhoto = data.data[0].photo4
                    } else {
                      profilePhoto = data.data[0].photo
                    }
            
          
         //console.log(data.data[0].plan_detail.advance_search)
        setUserPlanDetail(data.data[0].plan_detail)
        
         setFormData({

          name:data.data[0].name,
          gender:data.data[0].gender,
          photo:profilePhoto,
          planDetail:data.data[0].plan_detail,
          form_status:data.data[0].form_status,
            
  
        })
  
      } 
  
    }
  
  useEffect(() => {
    //console.log('header', planChangeStatus)
    if(userDetailLogin?._id){
    fetchUserDetail(userDetailLogin._id)
    } else {
      document.location.href='/';
    }
  
  }, [userDetailLogin, planChangeStatus])


  const userLogoutButton = () => {
      
      dispatch(userLogout())
      document.location.href=`/`
  
    }

    useEffect(() => {
      
      setOpenMegaMenu(false)
      setHeaderOpen(false);

    }, [location.pathname])


    useEffect(() => {
             // Initialize Bootstrap modal once (after first render)
             const modalConfirmEl = document.getElementById("confirmPopupHeaderId");
             if (modalConfirmEl) {
               modalInstanceConfirm.current = new window.bootstrap.Modal(modalConfirmEl);
             }
    
    
           }, []);


  const showConfirm = () => {
    setPopupMessage("0 view your matches, you must fill out your partner preferences, specifically at least Religion and Caste.")
    setConfirmYesNo(false)
    modalInstanceConfirm.current?.show();
  }

  const yesNoButton = (value) => {
    
    //console.log('confirm', value)
    setConfirmYesNo(false)
    if(value === 'Yes'){
    navigate("/partner-basic-detail-edit")
    }
    modalInstanceConfirm.current?.hide();
  }

  const showAdvanceForm = () => {
    //console.log(userPlanDetail?.advance_search)  
    if(String(userPlanDetail?.advance_search) === "true"){
      //console.log('kkk')
      setTimeout(() => navigate("/advance-search"), 100);
     
      } else {
      setPopupMessage(`You're currently on the ${userPlanDetail?.plan_id?.name || 'Basic'} plan. Kindly upgrade your plan to continue.`)
      setConfirmYesNo(true)
      modalInstanceConfirm.current?.show();
            
      }

  }
  const yesNoButtonTwo = (value) => {
    
    //console.log('confirm', value)
    setConfirmYesNo(false)
    if(value === 'Yes'){
    navigate("/membership-plan")
    }
    modalInstanceConfirm.current?.hide();
  }


  const checkProfileComplete = async (userId) => {
      const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/check-profile-complete`, {
          method: "POST",
          headers: { "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
           },
           body: JSON.stringify({user_id:userId})
          });
  
        const data = await res.json();
        //console.log('coplete', data)
        if(data.status){
          setProfileCompletion(data.completion)

        }
    }


    const handleCompleteProfile = (value) => {
      const profileValue = parseInt(value, 10); // handles "10%"

      switch (true) {
        case profileValue < 25:
          window.location.href = "/basic-details-edit";
          break;
        case profileValue < 35:
          window.location.href = "/contact-information-edit";
          break;
        case profileValue < 40:
          window.location.href = "/religion-edit";
          break;
        case profileValue < 50:
          window.location.href = "/location-detail-edit";
          break;
        case profileValue < 60:
          window.location.href = "/family-detail-edit";
          break;
        case profileValue < 85:
          window.location.href = "/education-detail-edit";
          break;
        case profileValue < 100:
          window.location.href = "/partner-basic-detail-edit";
          break;
        default:
          console.warn("Profile is 100% or invalid");
      }
    };
    
    useEffect(() => {
      if(userDetailLogin._id){
        checkProfileComplete(userDetailLogin._id)
      }

    }, [userDetailLogin])

  
  return (
    <>
    <ConfirmPopupHeader ref={modalConfirmRef} message={popupMessage} yesNoButton={confirmYesNo?yesNoButtonTwo:yesNoButton} />

    
    <button class="scrollToTop showBtn"><span id="progress-bar" style={{ "--scrollAmount": "19px" }}><svg width="48" height="48" viewBox="-5 -5 60 60" fill="none"><path stroke="#e85d95" stroke-width="2" d="M0.5,25a24.5,24.5 0 1,0 49,0a24.5,24.5 0 1,0 -49,0"></path></svg></span></button>
    <section
  className="headerSection headerTwo wow animate__fadeIn"
  data-wow-delay="0.2s"
>
  <div className="site-width sitewidths">
    <div className="headerWrapper">
      <div className="logoSection">
        <Link to="/dashboard">
          <img
            src={`${process.env.REACT_APP_BASE_URL}/assets/img/logo-light.png`}
            alt="Vivashri"
            title="Vivashri"
            oncontextmenu="return false;"
          />
        </Link>
      </div>
      <div className="allHeaders wow animate__fadeIn">
        <div className="mainHeaderSection">
          <div className="headerNav">
            <ul className="headerMenu">
              <li className="hasSub megaMenu megaMenu2">
                <Link to="#">
                  My Vivashri{" "}
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                    alt="down Icon"
                    className="dropdownicon"
                    style={{ marginLeft: 5 }}
                  />
                </Link>
                <div className="headerSubNav headerSubNavs">
                  <ul className="headerSubMenu">
                    {/* <li><h5>Horoscope</h5></li> */}
                    <li>
                      <Link to="/dashboard">Dashboard</Link>
                    </li>
                    <li>
                      <Link to="/my-profile/partner">Partner Preferences</Link>
                    </li>
                  </ul>
                  <ul className="headerSubMenu">
                    <li>
                      <Link to="/my-profile">My Profile</Link>
                    </li>
                    <li>
                      <Link to="/settings">Settings</Link>
                    </li>
                  </ul>
                  <ul className="headerSubMenu">
                    <li>
                      <Link to="/profile-photo-edit">My Photos</Link>
                    </li>
                    <li>
                      <Link to="#">Notification</Link>
                    </li>
                  </ul>
                </div>
              </li>
              <li className="hasSub megaMenu">
                <Link to="#">
                  Matches{" "}
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                    alt="down Icon"
                    className="dropdownicon"
                    style={{ marginLeft: 5 }}
                  />
                </Link>
                <div className="headerSubNav headerSubNavsse ">
                  <ul className="headerSubMenu headerSubMenuss ">
                    {/* <li><h5>Horoscope</h5></li> */}
                    <li>
                      
                      {formData.form_status === 'Completed' ? 
                      <Link to="/my-matches">My Matches</Link>
                      :
                      <Link onClick={showConfirm} to="#">My Matches</Link>
                      }
                    </li>
                    <li>
                      {formData.form_status === 'Completed' ?
                      <Link to="/today-matches">Today Matches</Link>
                      :
                      <Link onClick={showConfirm} to="#">Today Matches</Link>
                      }
                    </li>
                    <li>
                      {formData.form_status === 'Completed' ?
                      <Link to="/near-me">Near Me</Link>
                      :
                      <Link onClick={showConfirm} to="#">Near Me</Link>
                      }
                    </li>
                  </ul>
                </div>
              </li>
              <li className="hasSub megaMenu">
                <Link to="#">
                  Search{" "}
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                    alt="down Icon"
                    className="dropdownicon"
                    style={{ marginLeft: 5 }}
                  />
                </Link>
                <div className="headerSubNav headerSubNavsss">
                  <ul className="headerSubMenu headerSubMenuss">
                    {/* <li><h5>Horoscope</h5></li> */}
                    <li>
                      <Link to="/basic-search">Basic Search</Link>
                    </li>
                    
                    <li>
                      <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                    </li>
                  

                  </ul>
                </div>
              </li>
              <li className="hasSub megaMenu">
                <Link to="#">
                  Connect{" "}
                  <img
                    src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                    alt="down Icon"
                    className="dropdownicon"
                    style={{ marginLeft: 5 }}
                  />
                </Link>
                <div className="headerSubNav headerSubNavssss">
                  <ul className="headerSubMenu headerSubMenuss">
                    {/* <li><h5>Horoscope</h5></li> */}
                    <li>
                      {/* {formData.form_status === 'Completed' ? */}
                      <Link to="/inbox/received">Received</Link>
                      {/* // :
                      // <Link onClick={showConfirm} to="#">Received</Link>
                      // } */}
                    </li>
                    <li>
                      {/* {formData.form_status === 'Completed' ? */}
                      <Link to="/inbox/accepted">Accepted</Link>
                      {/* // :
                      // <Link onClick={showConfirm} to="#">Accepted</Link>
                      // } */}
                    </li>
                    { /* <li>
                      {formData.form_status === 'Completed' ?
                      <Link to="/inbox/decline">Decline</Link>
                      :
                      <Link onClick={showConfirm} to="#">Decline</Link>
                      }
                    </li>
                    */ }
                    <li>
                      {/* {formData.form_status === 'Completed' ? */}
                      <Link to="/inbox/sent">Sent</Link>
                      {/* // :
                      // <Link onClick={showConfirm} to="#">Sent</Link>
                      // } */}
                    </li>
                  </ul>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>

      
      <div className="headerButns dnone-but butt-pro-siz myprof-menu">
       
        <ul className="headerMenu">
          <li className="hasSub megaMenu" style={{padding:'0px'}}>
            <Link to="/dashboard" style={{ borderBottom: "none" }}>
                <div className='myprof-img'>
                  <img className="size-togle-pro" src={formData.gender && (
                                formData?.photo
                                      ? `${process.env.REACT_APP_BASE_URL_IMAGE}${formData.photo}`
                                      : formData?.gender === "Male"
                                      ? "assets/img/no-image-male.jpg"
                                      : "assets/img/no-image-female.jpg"
                            )}
                alt=""/>
                </div>
              <img
                src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                alt="down Icon"
                className="dropdownicon d-none d-lg-inline"
                style={{ marginLeft: 5 }}
              />
            </Link>
            <div className="headerSubNav headerSubNavsssss">
              <ul className="headerSubMenu" style={{width:'100%'}}>
                {/* <li><h5>Horoscope</h5></li> */}
                <li
                  style={{ backgroundColor: "#FFF9F0", padding: "15px 30px" }}
                >
                  <h6 style={{ fontSize: 16, marginBottom: 10 }}>
                    {formData.name}{" "}
                    <span style={{ color: "#E4189F", fontSize: 12 }}>
                      { /* (ID :&nbsp;600155) */ }
                    </span>
                  </h6>
                  <div className="col-12">
                    <div className="row">
                      <div className="col-7">
                        <h6 style={{ fontSize: 14 }}>
                          Active Plan: {formData.planDetail?.plan_id?.name === 'VIP'? 'VIP Shaadi':formData.planDetail?.plan_id?.name ? formData.planDetail?.plan_id?.name+' Plan':'Basic Plan'}
                        </h6>
                      </div>
                      <div className="col-5">
                        <h6 style={{ color: "#E4189F", fontSize: 13 }}>
                          
    {profileCompletion} {profileCompletion !== "100%" ? (
                          <span onClick={() => handleCompleteProfile(profileCompletion)}>
                            Complete Profile
                          </span>
                        ) : (
                          <span>Complete Profile</span>
                        )}

                        </h6>
                      </div>
                    </div>
                  </div>
                </li>
                <li
                  style={{ backgroundColor: "#ffffff", padding: "15px 30px" }}
                >
                  <div className="col-12">
                    <div className="row">
                      <div className="col-6">
                        <Link to="/my-profile" style={{ border: "none", fontSize: 13 }}>
                          <img
                            style={{ marginRight: 5 }}
                            src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/user-alt-1_svgrepo.com.png`}
                            alt=""
                          />
                          View My Profile
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link to="/shortlist" style={{ border: "none", fontSize: 13 }}>
                          <img
                            style={{ marginRight: 5 }}
                            src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/setting-1_svgrepo.com.png`}
                            alt=""
                          />
                          Shortlist
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link to="/photo-request" style={{ border: "none", fontSize: 13 }}>
                          <img
                            style={{ marginRight: 5 }}
                            src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/key_svgrepo.com.png`}
                            alt=""
                          />
                          Photo Request
                        </Link>
                      </div>
                      <div className="col-6">
                        <Link to="#" onClick={userLogoutButton} style={{ border: "none", fontSize: 13 }}>
                          <img
                            style={{ marginRight: 5 }}
                            src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/logout.png`}
                            alt=""
                          />
                          Logout
                        </Link>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </li>
        </ul>
      </div>
      
      { /* <div className="headerButns dnone-butts">
        <div className="headerRightMenuWrap">
          <ul className="headerRightMenu">
            <div className="hamburger is-md">
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
              <span
                className="hamburger-line"
                style={{ background: "#7C172B" }}
              />
            </div>
          </ul>
        </div>
      </div>
      */ }

      <div className="dropdownmenu wow animate__fadeInDown">
        <div className="headerNav">
          <ul className="headerMenu">
            <li className="hasSub megaMenu">
              <Link to="#" style={{ color: "#7C172B" }}>
                My Vivashri{" "}
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                  alt="down Icon"
                  className="dropdownicon"
                  style={{ marginLeft: 5 }}
                />
              </Link>
              <div className="headerSubNav headerSubNavs">
                <ul className="headerSubMenu">
                  {/* <li><h5>Horoscope</h5></li> */}
                  <li>
                    <Link to="/dashboard">Dashboard</Link>
                  </li>
                  <li>
                    <Link to="/my-profile/partner">Partner Preferences</Link>
                  </li>
                </ul>
                <ul className="headerSubMenu">
                  <li>
                    <Link to="/my-profile">My Profile</Link>
                  </li>
                  <li>
                    <Link to="/settings">Settings</Link>
                  </li>
                </ul>
                <ul className="headerSubMenu">
                  <li>
                    <Link to="/profile-photo-edit">My Photos</Link>
                  </li>
                  <li>
                    <Link to="#">Notification</Link>
                  </li>
                </ul>
              </div>
            </li>
            <li className="hasSub megaMenu">
              <Link to="#" style={{ color: "#7C172B" }}>
                Matches{" "}
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                  alt="down Icon"
                  className="dropdownicon"
                  style={{ marginLeft: 5 }}
                />
              </Link>
              <div className="headerSubNav headerSubNavss">
                <ul className="headerSubMenu headerSubMenuss">
                  {/* <li><h5>Horoscope</h5></li> */}
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/my-matches">My Matches</Link>
                    :
                    <Link onClick={showConfirm} to="#">My Matches</Link>
                    }
                  </li>
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/today-matches">Today Matches</Link>
                    :
                    <Link onClick={showConfirm} to="#">Today Matches</Link>
                    }
                  </li>
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/near-me">Near Me</Link>
                    :
                    <Link onClick={showConfirm} to="#">Near Me</Link>
                    }
                  </li>
                </ul>
              </div>
            </li>
            <li className="hasSub megaMenu">
              <Link to="#" style={{ color: "#7C172B" }}>
                Search{" "}
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                  alt="down Icon"
                  className="dropdownicon"
                  style={{ marginLeft: 5 }}
                />
              </Link>
              <div className="headerSubNav headerSubNavsss">
                <ul className="headerSubMenu headerSubMenuss">
                  {/* <li><h5>Horoscope</h5></li> */}
                  <li>
                    <Link href="/basic-search">Basic Search</Link>
                  </li>
                  
                  <li>
                    <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                  </li>
                  
                </ul>
              </div>
            </li>
            <li className="hasSub megaMenu">
              <Link to="#" style={{ color: "#7C172B" }}>
                Connect{" "}
                <img
                  src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                  alt="down Icon"
                  className="dropdownicon"
                  style={{ marginLeft: 5 }}
                />
              </Link>
              <div className="headerSubNav headerSubNavssss">
                <ul className="headerSubMenu headerSubMenuss">
                  {/* <li><h5>Horoscope</h5></li> */}
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/inbox/received">Received</Link>
                    :
                    <Link onClick={showConfirm} to="#">Received</Link>
                    }
                  </li>
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/inbox/accepted">Accepted</Link>
                    :
                    <Link onClick={showConfirm} to="#">Accepted</Link>
                    }
                  </li>
                  { /* <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/inbox/decline">Decline</Link>
                    :
                    <Link onClick={showConfirm} to="#">Decline</Link>
                    }
                  </li>
                  */ }
                  <li>
                    {formData.form_status === 'Completed' ?
                    <Link to="/inbox/sent">Sent</Link>
                    :
                    <Link onClick={showConfirm} to="#">Sent</Link>
                    }
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>


          <div className="headerButns dnone-buttsss">
                              <div className="headerRightMenuWrap">
                                <ul className="headerRightMenu headerRightMenus">
                                  <div className="hamburger is-md" onClick={toggleHeader}>
                                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                                    <span className="hamburger-line" style={{ background: "#7C172B" }} />
                                  </div>
                                </ul>
                              </div>
                            </div>
          
                            <div className={`dropdownmenu wow animate__fadeInDown ${isHeaderOpen ? "openMenu" : "closedMenu"}`}>
                              <div className="headerNav">
                                <ul className="headerMenu" style={{ color: "black" }}>
                                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenu}>
                                    <Link to="#" style={{ color: "#7C172B" }}>
                                      My Vivashri {" "}
                                      <img
                                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                                        alt="down Icon"
                                        className="dropdownicon"
                                        style={{ marginLeft: 5 }}
                                      />
                                    </Link>
                                    <div className={`headerSubNav ${openMegaMenu ? "openMegaMenu" : "openMegaMenuClosed"}`}>
                                      <ul className="headerSubMenu">
                                        {/* <li><h5>Horoscope</h5></li> */}
                                        <li>
                                          <Link to="/dashboard">Dashboard</Link>
                                        </li>
                                        <li>
                                          <Link to="/my-profile">My Profile</Link>
                                        </li>
                                        <li>
                                          <Link to="/profile-photo-edit">My Photos</Link>
                                        </li>
                                        <li>
                                          <Link to="/my-profile/partner">Partner Preference</Link>
                                        </li>
                                        <li>
                                          <Link to="/settings">Settings</Link>
                                        </li>
                                        <li>
                                          <Link to="#">Notification</Link>
                                        </li>
                                      </ul>
                                      
                                    </div>
                                  </li>
                                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuMatch}>
                                    <Link to="#" style={{ color: "#7C172B" }}>
                                      Matches {" "}
                                      <img
                                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                                        alt="down Icon"
                                        className="dropdownicon"
                                        style={{ marginLeft: 5 }}
                                      />
                                    </Link>
                                    <div className={`headerSubNav ${openMegaMenuMatch ? "openMegaMenuMatch" : "openMegaMenuClosedMatch"}`}>
                                      <ul className="headerSubMenu">
                                        {/* <li><h5>Horoscope</h5></li> */}
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/my-matches">My Matches</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">My Matches</Link>
                                          }
                                        </li>
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/today-matches">Today Matches</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Today Matches</Link>
                                          }
                                        </li>
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/near-me">Near Me</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Near Me</Link>
                                          }
                                        </li>
                                        
                                      </ul>
                                      
                                    </div>
                                  </li>
                                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuSearch}>
                                    <Link to="#" style={{ color: "#7C172B" }}>
                                      Search {" "}
                                      <img
                                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                                        alt="down Icon"
                                        className="dropdownicon"
                                        style={{ marginLeft: 5 }}
                                      />
                                    </Link>
                                    <div className={`headerSubNav ${openMegaMenuSearch ? "openMegaMenuSearch" : "openMegaMenuClosedSearch"}`}>
                                      <ul className="headerSubMenu">
                                        {/* <li><h5>Horoscope</h5></li> */}
                                        <li>
                                          <Link to="/basic-search">Basic Search</Link>
                                        </li>
                                        
                                        <li>
                                          <Link to="#" onClick={showAdvanceForm}>Advance Search</Link>
                                        </li>
                                      
                                        
                                      </ul>
                                      
                                    </div>
                                  </li>
                                  <li className="hasSub megaMenu position-relative" onClick={toggleMegaMenuInbox}>
                                    <Link to="#" style={{ color: "#7C172B" }}>
                                      Connect {" "}
                                      <img
                                        src={`${process.env.REACT_APP_BASE_URL}/assets/img/icons/dropdown-arrow.svg`}
                                        alt="down Icon"
                                        className="dropdownicon"
                                        style={{ marginLeft: 5 }}
                                      />
                                    </Link>
                                    <div className={`headerSubNav ${openMegaMenuInbox ? "openMegaMenuInbox" : "openMegaMenuClosedInbox"}`}>
                                      <ul className="headerSubMenu">
                                        {/* <li><h5>Horoscope</h5></li> */}
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/inbox/received">Received</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Received</Link>
                                          }
                                        </li>
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/inbox/accepted">Accepted</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Accepted</Link>
                                          }
                                        </li>
                                        { /* <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/inbox/decline">Decline</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Decline</Link>
                                          }
                                        </li>
                                        */ }
                                        <li>
                                          {formData.form_status === 'Completed' ?
                                          <Link to="/inbox/sent">Sent</Link>
                                          :
                                          <Link onClick={showConfirm} to="#">Sent</Link>
                                          }
                                        </li>
                                        
                                        
                                      </ul>
                                      
                                    </div>
                                  </li>
                                  <li>
                                                          {" "}
                                                          <Link to="#" onClick={userLogoutButton}>Logout</Link>
                                                        </li>
                                  
                                  
                                  

                                </ul>
                                
                              </div>
                            </div>

      
    </div>
  </div>
</section>
</>


  )
}

export default HeaderUser
